import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLang } from "../lib/providers";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterConfirmPage() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const [state, setState] = useState({ loading: true, ok: false, reason: "", email: "", promo_code: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ loading: false, ok: false, reason: "missing_token" });
      return;
    }
    axios.get(`${API}/newsletter/confirm`, { params: { token } })
      .then((r) => setState({ loading: false, ...r.data }))
      .catch(() => setState({ loading: false, ok: false, reason: "error" }));
  }, [params]);

  const goHome = (
    <Link to="/" className="inline-block mt-6 px-6 py-3 bg-neon text-black font-black uppercase tracking-widest text-sm hover:opacity-90" data-testid="newsletter-confirm-home">
      {lang === "ar" ? "العودة إلى المتجر" : "Retour à la boutique"}
    </Link>
  );

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-black">
      <div className="max-w-md w-full text-center border border-white/10 p-8 bg-black/60" dir={lang === "ar" ? "rtl" : "ltr"}>
        {state.loading ? (
          <>
            <Loader2 className="w-10 h-10 text-neon mx-auto animate-spin mb-4" />
            <p className="text-white/70">{lang === "ar" ? "جارٍ التأكيد..." : "Confirmation en cours..."}</p>
          </>
        ) : state.ok ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-neon mx-auto mb-4" />
            <h1 className="text-2xl sm:text-3xl font-black uppercase tracking-tight mb-2">
              {lang === "ar" ? "✅ تم تأكيد اشتراكك !" : "✅ Inscription confirmée !"}
            </h1>
            <p className="text-sm text-white/70 mb-2" data-testid="newsletter-confirm-success">
              {state.already_confirmed
                ? (lang === "ar" ? "بريدك الإلكتروني مؤكد بالفعل." : "Votre email était déjà confirmé.")
                : (lang === "ar"
                    ? "تحقق من بريدك الإلكتروني — أرسلنا لك كود الخصم الخاص بك !"
                    : "Vérifiez votre boîte mail — nous vous avons envoyé votre code promo !")}
            </p>
            {state.promo_code && (
              <div className="mt-4 p-4 border-2 border-dashed border-neon bg-neon/5">
                <p className="text-[10px] uppercase tracking-widest text-white/60">
                  {lang === "ar" ? "كود الخصم الخاص بك" : "Votre code promo"}
                </p>
                <p className="text-2xl font-black text-neon font-mono tracking-widest mt-1" data-testid="newsletter-confirm-promo">{state.promo_code}</p>
              </div>
            )}
            {goHome}
          </>
        ) : (
          <>
            <XCircle className="w-14 h-14 text-clay mx-auto mb-4" />
            <h1 className="text-2xl font-black uppercase tracking-tight mb-2">
              {lang === "ar" ? "❌ تعذر التأكيد" : "❌ Confirmation impossible"}
            </h1>
            <p className="text-sm text-white/70" data-testid="newsletter-confirm-error">
              {state.reason === "expired"
                ? (lang === "ar" ? "انتهت صلاحية الرابط (24 ساعة). يرجى الاشتراك مرة أخرى." : "Le lien a expiré (24h). Veuillez vous réinscrire.")
                : state.reason === "missing_token"
                ? (lang === "ar" ? "رابط غير صالح." : "Lien invalide.")
                : (lang === "ar" ? "تعذرت معالجة تأكيدك. يرجى المحاولة مرة أخرى." : "Impossible de traiter votre confirmation. Réessayez.")}
            </p>
            {goHome}
          </>
        )}
      </div>
    </div>
  );
}
